// Nome do projeto exibido na UI.
//
// Por exigência de período eleitoral, o nome antigo ("Filhos de Minas") foi substituído
// pelo nome instituído pela Resolução SES-MG 9.984/2025. Fonte única de verdade — qualquer
// exibição do nome do projeto na interface deve usar esta constante.
export const PROJECT_NAME =
  'Bem vindo ao projeto instituído pela Resolução SES-MG 9.984/2025';

export default PROJECT_NAME;
